import { on, createReducer, Action } from '@ngrx/store';
import { ItemsActions } from './items.actions';
import {ItemSummary} from '@emm/core/models/item-summary.model';

const initialState: ItemSummary = null;

const itemSummaryReducer = createReducer(
    initialState,
    on(ItemsActions.select, (state, { item }) => ({
        ...item
    }))
);

export function reducer(state: ItemSummary | undefined, action: Action) {
    return itemSummaryReducer(state, action);
}
